import {
	Account,
	AppwriteException,
	Client,
	Functions,
	Locale,
	Messaging,
	Storage,
	TablesDB,
	Teams,
} from "appwrite";

export class AppwriteClient {
	protected client: Client = new Client()
		.setEndpoint(import.meta.env.VITE_APPWRITE_ENDPOINT)
		.setProject(import.meta.env.VITE_APPWRITE_PROJECT_ID);

	public static databaseId = import.meta.env.VITE_APPWRITE_DATABASE_ID;

	get account() {
		return new Account(this.client);
	}

	get messaging() {
		return new Messaging(this.client);
	}

	get tablesDB() {
		return new TablesDB(this.client);
	}

	get storage() {
		return new Storage(this.client);
	}

	get functions() {
		return new Functions(this.client);
	}

	get teams() {
		return new Teams(this.client);
	}

	get locale() {
		return new Locale(this.client);
	}

	subscribe(...args: Parameters<Client["subscribe"]>) {
		return this.client.subscribe(...args);
	}
}

export const getAppwriteClient = () => {
	return new AppwriteClient();
};

export const getCurrentUser = async () => {
	try {
		const appwriteClient = getAppwriteClient();
		return await appwriteClient.account.get();
	} catch (error) {
		if (error instanceof AppwriteException && error.code === 401) {
			return null;
		}
		console.error("Failed to fetch current account:", error);
		throw error;
	}
};
